import React from "react";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import AllChats from "../../../sections/MessageCentre/AllChats";
import { BUSINESS_INBOX_CONTENT_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const Blocked = () => {
  return (
    <DashboardMainContainer className={"!bg-white"}>
      <div className={BUSINESS_INBOX_CONTENT_CLASS}>
        <div className="bg-white overflow-hidden">
          <AllChats moveToChat={() => {}} filterType="blocked" />
        </div>
      </div>
    </DashboardMainContainer>
  );
};

export default Blocked;
